import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { INatRepCommandResult } from '../../models/INatRepCommandResult';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ICountry } from '../../models/ICountry';
import { FileService } from '../../services/file.service';
import { S1DataService } from '../../services/s1data.service';
import { NatRepServiceService } from '../../services/nat-rep-service.service';

@Component({
  selector: 'nat-rep-settings',
  templateUrl: './nat-rep-settings.component.html',
  styleUrls: ['./nat-rep-settings.component.css']
})
export class NatRepSettingsComponent implements OnInit {
  natRepSources$: Observable<string[]>;
  countryList$: Observable<Array<ICountry>>;
  countryCode: string;
  soureName: string;
  
  uploadResults: INatRepCommandResult;
  uploadResultStr: string;

  deleteResults: INatRepCommandResult;
  deleteResultStr: string;

  form: FormGroup;

  updating: boolean;
  deleting: boolean;

  constructor(
    private fb: FormBuilder,
    private fileService: FileService,
    private natRepService: NatRepServiceService,
    private dataService: S1DataService) {
    this.form = this.fb.group({ onFileUpload: null });
  }

  ngOnInit() {
    this.countryList$ = this.dataService.getCountries();
    this.natRepSources$ = this.natRepService.GetSourceNames();
  }

  onGetNatRep() {
    if (this.soureName == undefined || this.countryCode == undefined)
      alert("Source and country are both mandatory to download file");
    else
      this.fileService.downloadSecureFile(this.natRepService.GetSourceExcelPath(this.soureName, this.countryCode), `NatRepQuotas${this.countryCode||""}${this.soureName||""}.xlsx`);
  }

  onUpdateNatRep() {
    this.updating = true;
    this.uploadResultStr = null;
    this.natRepService.UpdateNatRepSource(this.soureName, this.countryCode, this.prepareSave("onFileUpload"))
      .subscribe(x => {
        this.uploadResultStr = null;
        this.uploadResults = x;
        this.updating = false;
      },
        err => {
          this.uploadResultStr = "error!";
          this.updating = false;
      });
  }


  onDeleteNatRep() {
    this.deleting = true;
    this.deleteResultStr = null;
    this.natRepService.DeleteNatRepSource(this.soureName, this.countryCode)
      .subscribe(x => {
        this.deleteResultStr = null;
        this.deleteResults = x;
        this.deleting = false;
      },
        err => {
          this.deleteResultStr = "error!";
          this.deleting = false;
        });
  }

  private prepareSave(fileName): FormData {
    if (!this.form.get(fileName).value)
      return null;
    let input = new FormData();
    input.append('file', this.form.get(fileName).value);
    return input;
  }

  onUpdateNatRepFile(event) {
    if (event.target.files.length > 0) {
      let file = event.target.files[0];
      this.form.get('onFileUpload').setValue(file);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/nat-rep-settings/nat-rep-settings.component.ts